import { useTranslation } from 'react-i18next';
import PaymentModule from '@/containers/PaymentModule';
import { useGetMe } from '@/hooks/shared/useGetMe';
import WarningBlock from '@/components/UI/WarningBlock';
import { ROLES } from '@/helpers/constants';
import s from './index.module.scss';

const PaymentsAddFundsPage = () => {
  const { user } = useGetMe();
  const { t } = useTranslation('cash');

  if (!user) return null;

  const canAddCash = user.role === ROLES.founder;

  return (
    <div className={s.wrapper}>
      {!canAddCash && (
        <WarningBlock withBorder className={s.message}>
          <div className="f-16 f-400">{t('add_funds_page.add_funds_unavailable_message')}</div>
        </WarningBlock>
      )}
      <PaymentModule disabled={!canAddCash} />
    </div>
  );
}

export default PaymentsAddFundsPage;
